import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import FormDivider from '../common/components/FormDivider'
import CollectRSVPSection from '../common/components/formInputs/CollectRSVPSection'
import AutomatedRemindersSection from '../common/components/formInputs/AutomatedRemindersSection'
import ToggleInput from '../common/components/formInputs/ToggleInput'
import PostEventReviewSection from '../common/components/formInputs/PostEventReviewSection'
import SwitchInput from '../common/components/formInputs/SwitchInput'
import { getVisibilityOptions } from '../common/helpers'

const FourthStep = ({ displayStep, formValues, socialLinksOptions, setFieldValue }) => {
  const { t } = useTranslation(['eventManagement'])

  useEffect(() => {
    if (!formValues?.building?.isHoa) {
      setFieldValue('householdMembersAllowed', false)
    }
  }, [formValues?.building?.isHoa])

  if (!displayStep) {
    return null
  }

  return (
    <React.Fragment>
      <FormDivider />
      <div className="columns">
        <div className="column is-12">
          <p>{t('eventManagement:common.attendees')}</p>
        </div>
      </div>
      {formValues.building.isHoa && (
        <div className="columns">
          <ToggleInput
            columnSize={12}
            name="householdMembersAllowed"
            value={formValues.householdMembersAllowed}
            label={t('eventManagement:common.allowHouseholdMembers')}
            tooltip={
              <>
                <p>{t('eventManagement:common.allowHouseholdMembersTooltipLine1')}</p>
                <p>{t('eventManagement:common.allowHouseholdMembersTooltipLine2')}</p>
                <p>{t('eventManagement:common.allowHouseholdMembersTooltipLine3')}</p>
              </>
            }
            onToggle={setFieldValue}
          />
        </div>
      )}
      <FormDivider />
      <div className="columns">
        <div className="column is-12">
          <p>{t('eventManagement:common.rsvp')}</p>
        </div>
      </div>
      <CollectRSVPSection
        collectRSVP={formValues.collectRSVP}
        signUpLink={formValues.signUpLink}
        setFieldValue={setFieldValue}
      />
      <div className="columns">
        <ToggleInput
          columnSize={12}
          name="hideAttendees"
          value={formValues.hideAttendees}
          label={t('eventManagement:common.hideAttendeeList')}
          tooltip={
            <>
              <p>{t('eventManagement:common.hideAttendeeListTooltipLine1')}</p>
              <p>{t('eventManagement:common.hideAttendeeListTooltipLine2')}</p>
              <p>{t('eventManagement:common.hideAttendeeListTooltipLine3')}</p>
            </>
          }
          onToggle={setFieldValue}
        />
      </div>
      <FormDivider />
      <div className="columns">
        <div className="column is-12">
          <p>{t('eventManagement:common.communication')}</p>
        </div>
      </div>
      <AutomatedRemindersSection
        automatedRemindersToggle={formValues.automatedRemindersToggle}
        remindRsvp={formValues.remindRsvp}
        remindRsvpValues={formValues.remindRsvpValues}
        remindAll={formValues.remindAll}
        remindAllValues={formValues.remindAllValues}
        timeStart={formValues.timeStart}
        setFieldValue={setFieldValue}
      />
      <PostEventReviewSection
        askForPostEventReview={formValues.askForPostEventReview}
        positiveReview={formValues.positiveReview}
        socialLinksOptions={socialLinksOptions}
        socialLinkService={formValues.socialLinkService}
        replyTo={formValues.replyTo}
        buildingId={formValues.building?.id}
        setFieldValue={setFieldValue}
      />
      <FormDivider />
      <SwitchInput
        columnSize={12}
        label={t('eventManagement:common.visibility')}
        name="isPrivate"
        value={formValues.isPrivate}
        tooltip={<p>{t('eventManagement:common.visibilityTooltip')}</p>}
        options={getVisibilityOptions(t)}
        setFieldValue={setFieldValue}
      />
    </React.Fragment>
  )
}

FourthStep.propTypes = {
  displayStep: PropTypes.bool,
  formValues: PropTypes.object.isRequired,
  socialLinksOptions: PropTypes.array,
  setFieldValue: PropTypes.func.isRequired,
}

export default FourthStep
